import { Cart } from '@/cart/types'

export type CartStore = {
  cart: Cart | null
  error: string | null
}

export type Store = {
  cartStore: CartStore
}

export abstract class ComponentData {
  protected $store: Store
}
